import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=67d68300&scoped=true&"
import script from "./Sample.vue?vue&type=script&lang=js&"
export * from "./Sample.vue?vue&type=script&lang=js&"
import style0 from "./Sample.vue?vue&type=style&index=0&id=67d68300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d68300",
  null
  
)

export default component.exports